module.exports = __webpack_public_path__ + "img/w9.746b4ef6.svg";